import { GlobalDocumentContainer } from './GlobalDocumentContainer'
import { GlobalDocumentType } from 'src/enums'

export const GlobalDocumentLocalityContainer: React.FC = () => {
  return <GlobalDocumentContainer globalDocumentType={GlobalDocumentType.Locality} />
}

export default GlobalDocumentLocalityContainer
